import React from "react";

export default function ({
  size,
  circled,
  className = "",
}: {
  size?: number;
  circled?: boolean;
  className?: string;
}) {
  const svg = (
    <svg
      width={size || 24}
      height={size || 24}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className || ""}
    >
      <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
      <line x1="12" y1="9" x2="12" y2="13"></line>
      <line x1="12" y1="17" x2="12.01" y2="17"></line>
    </svg>
  );
  if (circled) {
    return <div className={"ib circled-icon" + " " + className}>{svg}</div>;
  }
  return svg;
}
